import { useEffect, useRef, useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { BiPlus, BiSearch } from "react-icons/bi";
import { FaChevronUp, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import getUsersCities from "../../Hooks/getUsersCities";
import { SEARCH_KEY, TOKEN_KEY } from "../../Utils/Constants";
import useWindowDimensions from "../Common/Dimension/Dimension";
import CityChange from "./City/CityChange";
import "./Navbar.css";
import AddProduct from "../Users/AddProduct";
import { baseUrl } from "../../shared/baseUrl";
import { checkAuth } from "../../Utils/CheckAuthentication";
import { createNotification } from "../Common/CreateNotification";

function NavbarUI({ setLoginOpen, setActiveIndex, logout }) {
    const user = useSelector((state) => state.user.user);
    const [pageOffset, setScrollPosition] = useState(0);
    // const [user, setUser] = useState(null);
    const [logHover, setLogHover] = useState(false);
    const [accHover, setAccHover] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const { width } = useWindowDimensions();
    const [openAddProduct, setOpenAddProduct] = useState(false);
    const [cityOptionForAddingProduct, setCityOptionAddingProduct] = useState("");
    const [categoryOption, setCategoryOption] = useState("");
    const [uploadedImages, setUploadedImages] = useState([]);
    const [isProductAdded, setIsProductAdded] = useState("");
    const [cityOption, setCityOption] = useState("");

    useEffect(() => {
        const init = async () => {
            const userCities = await getUsersCities();
            setCityOptionAddingProduct(userCities);
            getCategories();
            fetchUploadedImages();
        };

        init();
    }, []);

    const getCategories = async () => {
        await fetch(baseUrl + "all-categories")
            .then((res) => res.json())
            .then((res) => {
                setCategoryOption(res.data);
            })
            .catch((e) => console.log(e.message));
    };

    const fetchUploadedImages = () => {
        fetch(baseUrl + "uploaded-images", {
            method: "POST",
            headers: {
                Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
            },
        })
            .then((res) => checkAuth(res))
            .then((res) => {
                if (res.success) {
                    setUploadedImages(res.images);
                } else {
                    createNotification("error", "Failed to get uploaded images");
                }
            })
            .catch((err) => {
                createNotification("error", "Failed to get uploaded images");
            });
    };

    const PostFreeButton = (user) => {
        const handleAddProduct = (user) => {
            if (!user.user) {
                setLoginOpen(true);
                setActiveIndex("2");
            } else {
                setOpenAddProduct(true);
            }
        };
        return (
            <button
                className="thrift-btn  me-1"
                onClick={() => {
                    handleAddProduct(user);
                }}
            >
                <BiPlus className="h-4 w-4" /> Upload for free
                {openAddProduct && (
                    <AddProduct
                        onProductAdded={() => {
                            setIsProductAdded(new Date().getTime());
                        }}
                        uploadedImages={uploadedImages}
                        cityOption={cityOptionForAddingProduct}
                        categoryOption={categoryOption}
                        isOpen={openAddProduct}
                        onClose={() => {
                            setOpenAddProduct(false);
                        }}
                    />
                )}
            </button>
        );
    };
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    useEffect(() => {
        const getCities = async () => {
            const userCities = await getUsersCities();
            setCityOption(userCities);
        };
        getCities();
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // const getCities = async () => {
    //     await fetch(baseUrl + 'all-cities')
    //         .then((res) => res.json())
    //         .then((res) => {
    //             var tempArr = [];

    //             res.data.forEach((res) => {
    //                 tempArr.push({ value: res.id, label: res.city_name });
    //             });
    //             setCityOption([...tempArr]);
    //         })
    //         .catch(e => console.log(e.message));
    // }
    const onDivHover = () => {
        setShowMenu(true);
    };
    const onDiv = () => {
        setShowMenu(false);
    };
    const accEnter = () => {
        setAccHover(!accHover);
    };
    const logEnter = () => {
        setLogHover(!logHover);
    };

    return (
        <div>
            <Navbar
                bg="light"
                expand="lg"
                className={`${pageOffset > 66 && width > 768 ? "fixed-top" : ""}`}
            >
                <Container>
                    <Navbar.Brand>
                        <Link to="/">
                            <img
                                src="/assets/images/logo.png"
                                width="40"
                                height="40"
                                className="d-inline-block align-top"
                                alt="Thrift Store Nepal"
                            />
                        </Link>
                    </Navbar.Brand>

                    <div className="d-flex d-lg-none mx-auto w-75">
                        <SearchBar />
                    </div>
                    <Navbar.Collapse id="basic-navbar-nav d-flex justify-content-between">
                        <div className="d-none d-lg-block mx-auto w-50">
                            <SearchBar />
                        </div>
                        <div>
                            <PostFreeButton user={user} />
                        </div>
                        <div className="d-flex my-auto ms-0 ms-lg-3">
                            {user === null ? (
                                <div className="mt-2 mt-lg-0 small">
                                    <button
                                        className="thrift-btn  me-1"
                                        onClick={() => {
                                            setLoginOpen(true);
                                            setActiveIndex("1");
                                        }}
                                    >
                                        {" "}
                                        Login{" "}
                                    </button>{" "}
                                    |{" "}
                                    <button
                                        className="thrift-btn ms-1"
                                        onClick={() => {
                                            setLoginOpen(true);
                                            setActiveIndex("2");
                                        }}
                                    >
                                        {" "}
                                        Sign Up{" "}
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div
                                        className="d-flex"
                                        style={{ cursor: "default" }}
                                        onMouseLeave={onDiv}
                                        onMouseEnter={onDivHover}
                                    >
                                        <p className="my-auto">{user.name}</p>
                                        <img
                                            src={
                                                user.avatar ??
                                                "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                                                user.name
                                            }
                                            // src={user.avatar}
                                            className=" d-flex my-auto ms-1"
                                            alt={user.name}
                                            style={{
                                                height: 40,
                                                width: 40,
                                                borderRadius: 20,
                                                objectFit: "cover",
                                            }}
                                        />
                                        <div className={`dropdown-user ${showMenu ? "hover" : ""}`}>
                                            <div
                                                onMouseEnter={accEnter}
                                                onMouseLeave={accEnter}
                                                className="py-2 border-bottom "
                                            >
                                                <Link
                                                    to={"/users/myaccount"}
                                                    className="text-decoration-none text-black d-flex"
                                                >
                                                    <FaUser
                                                        style={{
                                                            transition: "0.5s all",
                                                            opacity: accHover ? 1 : 0,
                                                            transform: accHover
                                                                ? "translateX(100%)"
                                                                : "translateX(0)",
                                                        }}
                                                        className="my-auto"
                                                    />
                                                    <p
                                                        className="my-auto"
                                                        style={{
                                                            marginLeft: accHover ? "10px" : "0px",
                                                            transition: "0.5s all",
                                                            transform: accHover
                                                                ? "translateX(10%)"
                                                                : "translateX(0)",
                                                        }}
                                                    >
                                                        My Account
                                                    </p>
                                                </Link>
                                            </div>
                                            <div
                                                onMouseEnter={logEnter}
                                                onMouseLeave={logEnter}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    logout();
                                                }}
                                                className="py-2 d-flex cursor-pointer"
                                            >
                                                <FaSignOutAlt
                                                    style={{
                                                        transition: "0.5s all",
                                                        opacity: logHover ? 1 : 0,
                                                        transform: logHover
                                                            ? "translateX(100%)"
                                                            : "translateX(0)",
                                                    }}
                                                    className="my-auto"
                                                />
                                                <p
                                                    className="my-auto"
                                                    style={{
                                                        marginLeft: logHover ? "10px" : "0px",
                                                        transition: "0.5s all",
                                                        transform: logHover
                                                            ? "translateX(10%)"
                                                            : "translateX(0)",
                                                    }}
                                                >
                                                    Logout
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <CityChange
                cityOption={cityOption}
                pageOffset={pageOffset}
                width={width}
            />

            {pageOffset > 200 && (
                <div
                    className="cursor-pointer"
                    onClick={() => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    style={{ position: "fixed", bottom: 0, right: "5%", zIndex: 500 }}
                >
                    <div
                        style={{
                            background: "#00000080",
                            borderTopRightRadius: "4px",
                            borderTopLeftRadius: "4px",
                        }}
                        className="p-2"
                    >
                        <FaChevronUp size="20" color="#ffffff" />
                    </div>
                </div>
            )}
        </div>
    );
}
export default NavbarUI;

function SearchBar() {
    const [searchQuery, setSearchQuery] = useState("");
    const [localSearch, setLocalSearch] = useState([]);

    const inputRef = useRef();
    const ulRef = useRef();

    useEffect(() => {
        if (localStorage.getItem(SEARCH_KEY) !== null) {
            setLocalSearch(JSON.parse(localStorage.getItem(SEARCH_KEY)));
        }

        const storedQuery = sessionStorage.getItem("selectedQuery") || "";
        setSearchQuery(storedQuery);
        inputRef.current.addEventListener("click", (event) => {
            event.stopPropagation();
            ulRef.current.style.display = "block";
        });
        document.addEventListener("click", (event) => {
            try {
                ulRef.current.style.display = "none";
            } catch (e) {
                console.log(e.message);
            }
        });

        ulRef.current.style.display = "none";
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        addToLocalSearch(searchQuery);
        windowReplace(searchQuery);
    };

    const windowReplace = (query) => {
        sessionStorage.setItem("selectedQuery", query);
        window.location.replace(
            `${window.location.origin}/products?search=${query}`
        );
    };

    const addToLocalSearch = (searchTerm) => {
        var tempArr = localSearch;
        tempArr.push(searchTerm);
        setLocalSearch([...tempArr]);
        localStorage.setItem(SEARCH_KEY, JSON.stringify(tempArr));
    };

    // const removeFromLocalSearch = (index) => {
    //     if (index !== -1) {
    //         var tempArr = localSearch;
    //         tempArr.splice(index, 1);
    //         setLocalSearch([...tempArr]);
    //         localStorage.setItem(SEARCH_KEY, JSON.stringify(tempArr));
    //     }
    //     else {
    //         setLocalSearch([]);
    //         localStorage.removeItem(SEARCH_KEY);
    //     }
    // }

    return (
        <form onSubmit={handleSearch} className="w-100">
            <div className="row no-gutters align-items-center position-relative">
                <div className="px-0">
                    <input
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                        }}
                        ref={inputRef}
                        className={`form-control`}
                        type="search"
                        placeholder="Search items . . ."
                    />
                </div>
                <button
                    type="submit"
                    className="btn-sm rounded text-decoration-none border shadow-sm"
                    style={{
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: 40,
                        position: "absolute",
                    }}
                >
                    <BiSearch size={20} />
                </button>

                {localSearch.length > 0 ? (
                    <div
                        ref={ulRef}
                        style={{
                            maxHeight: "20vh",
                            overflowY: "scroll",
                            width: "100%",
                            position: "absolute",
                            background: "white",
                            zIndex: 1001,
                            top: "110%",
                            border: "1px solid #EC008C",
                            borderRadius: "5px",
                            padding: "5px",
                        }}
                    >
                        <>
                            {[...new Set(localSearch.filter((item) => item.length > 0))].map(
                                (item, index) => (
                                    <Link
                                        onClick={() => {
                                            sessionStorage.setItem("selectedQuery", item);
                                            setSearchQuery(item);
                                        }}
                                        to={`/products?search=${item}`}
                                        key={index}
                                        className="col-12 text-decoration-none search-item"
                                        style={{ cursor: "pointer", fontSize: 12 }}
                                    >
                                        <p>{item}</p>
                                    </Link>
                                )
                            )}
                        </>
                    </div>
                ) : (
                    <div ref={ulRef}></div>
                )}
            </div>
        </form>
    );
}
